import { useTranslation } from "react-i18next";
import {  IDateModeFilterProps } from "../../../interfaces";
import { ChevronDownIcon, ChevronUpIcon } from "lucide-react";
import { useClickOutside } from "../../../hooks/ClickOutsideHook";

export const GaDateModeFilter = ({ onChange, filterOptions, filter }: IDateModeFilterProps) => {
    const { t } = useTranslation("general");
    const [ref, viewModeOptions, setViewModeOptions] = useClickOutside<HTMLDivElement>();

    function handleModeClick(): void {
        setViewModeOptions(!viewModeOptions);
    }

    function handleChange(modeKey: string): void {
        onChange(modeKey);
        setViewModeOptions(!viewModeOptions);
    }

    return (
        <>
            <div ref={ref} className="ga-form-field ar-ga-dropdown">
                <label className="ga-form-field__label">
                    <span className="ga-form-field__label-text">{t("Mode")}</span>
                </label>
                <button
                    type="button"
                    className="ga-select ar-w-175"
                    onClick={handleModeClick}
                >
                    <div className="ga-select__value">{filterOptions.DateModes[filter.DateFilterMode]}</div>
                    {!viewModeOptions && <ChevronDownIcon className="ga-select__arrow" size={16} />}
                    {viewModeOptions && <ChevronUpIcon className="ga-select__arrow" size={16} />}
                </button>
                {viewModeOptions &&
                    <div className="ga-dropdown">
                        {Object.entries(filterOptions.DateModes).map(([modeKey, modeLabel]) => (
                            <button
                                key={modeKey}
                                className={`ga-dropdown__item ${modeKey === filter.DateFilterMode ? "ga-dropdown__item--selected" : ""}`}
                                onClick={() => handleChange(modeKey)}
                                type="button"
                            >
                                <div className="ga-dropdown__item-label">{modeLabel}</div>
                            </button>
                        ))}
                    </div>
                }
            </div>
        </>
    )
}